import type { ThreadId } from "@amoreg/contracts";

import { useActiveOrg } from "~/state/orgs";
import { ComposerSpacePicker } from "../home/HomeSpaces";

interface DraftHeroHeadlineProps {
  readonly threadId: ThreadId;
  readonly activeProjectTitle: string | null;
}

/**
 * The draft hero asks where the chat should live: its space, or the org when
 * it has none, as T3 Code's hero names the project. Switching tenants stays
 * the sidebar org switcher's job. The workspace title (== the org name, by
 * the mirror invariant) is the fallback when the org directory hasn't
 * answered yet.
 */
export function DraftHeroHeadline({ threadId, activeProjectTitle }: DraftHeroHeadlineProps) {
  const activeOrg = useActiveOrg();
  const tenantName = activeOrg?.name ?? activeProjectTitle;

  return (
    <h1 className="mx-auto w-full max-w-5xl text-center font-normal text-2xl text-foreground tracking-tight sm:text-3xl">
      {tenantName ? (
        <>
          What should we work on in{" "}
          <ComposerSpacePicker threadId={threadId} draft orgLabel={tenantName} variant="headline" />?
        </>
      ) : (
        <>What should we work on?</>
      )}
    </h1>
  );
}
